import { render, staticRenderFns } from "./StatisticsGrossProfitExchangeIncome.vue?vue&type=template&id=5e03c95a&scoped=true&"
import script from "./StatisticsGrossProfitExchangeIncome.vue?vue&type=script&lang=js&"
export * from "./StatisticsGrossProfitExchangeIncome.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsGrossProfitExchangeIncome.vue?vue&type=style&index=0&id=5e03c95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03c95a",
  null
  
)

export default component.exports